export default __webpack_public_path__ + "static/media/logo-lydian-white.96e33a3f.svg";